import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useSearchParams, Link } from 'react-router';
import { Button } from '@/components/ui/Button';
import { EnrollmentTable } from '@/features/enrollments/components/EnrollmentTable';
// Stub data — replaced by API hook later
export const STUB_ENROLLMENTS = [
    {
        id: '1',
        patientId: '1',
        patientName: 'Ashley Carter',
        treatmentType: 'Microneedling',
        enrollmentDate: '28 Mar 2026',
        consentState: 'granted',
        studyDay: 8,
        lastScanDate: '4 Apr 2026',
    },
    {
        id: '2',
        patientId: '2',
        patientName: 'Jennifer Mitchell',
        treatmentType: 'Chemical Peel',
        enrollmentDate: '1 Apr 2026',
        consentState: 'pending',
        studyDay: null,
        lastScanDate: null,
    },
    {
        id: '3',
        patientId: '3',
        patientName: 'Sarah Thompson',
        treatmentType: 'Laser',
        enrollmentDate: '15 Mar 2026',
        consentState: 'granted',
        studyDay: 21,
        lastScanDate: '4 Apr 2026',
    },
    {
        id: '4',
        patientId: '4',
        patientName: 'Emily Davis',
        treatmentType: 'Microneedling',
        enrollmentDate: '2 Apr 2026',
        consentState: 'denied',
        studyDay: null,
        lastScanDate: null,
    },
];
export function EnrollmentsPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const patientFilter = searchParams.get('patient');
    const enrollments = patientFilter
        ? STUB_ENROLLMENTS.filter((e) => e.patientId === patientFilter)
        : STUB_ENROLLMENTS;
    const filteredPatientName = patientFilter
        ? STUB_ENROLLMENTS.find((e) => e.patientId === patientFilter)?.patientName
        : null;
    return (_jsxs("div", { className: "flex flex-col gap-6", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "flex flex-col gap-1", children: [filteredPatientName && (_jsxs(Link, { to: "/enrollments", className: "text-[13px] font-normal text-on-surface-variant hover:text-primary flex items-center gap-1", children: [_jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", children: _jsx("path", { d: "M9 11L5 7l4-4" }) }), "All enrollments"] })), _jsx("h1", { className: "text-[22px] font-bold text-on-surface", children: filteredPatientName ? filteredPatientName : 'Enrollments' })] }), _jsx(Button, { variant: "primary", onClick: () => navigate('/enrollments/new'), children: "New enrollment" })] }), _jsx(EnrollmentTable, { enrollments: enrollments, onNewEnrollment: () => navigate('/enrollments/new') })] }));
}
